/**
 * Style File — Sourcing screen (formerly "Materials"). One of the 7 process
 * screens reached from Overview's "Work on this style" rail
 * (`style-overview-page.tsx`). Route path stays `$styleId.materials.tsx` —
 * only the visible label changed — to avoid touching the other links into
 * this route (`inward-page.tsx`).
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { Alert } from "@flint/ui";
import { trpc } from "../../../lib/trpc.js";
import type { StyleStatus } from "../lib/status.js";
import { StyleCockpitChrome, SectionCard } from "./style-cockpit-chrome.js";
import { MaterialsSection } from "./materials-section.js";

export function StyleMaterialsPage({ styleId }: { styleId: string }) {
  const query = trpc.styles.get.useQuery({ id: styleId });

  if (query.isLoading) return <p className="p-6 text-sm text-muted">Loading…</p>;
  if (query.error || !query.data) {
    return (
      <div className="p-6">
        <Alert intent="bad" title="Couldn't load style file" description={query.error?.message ?? "Not found."} />
      </div>
    );
  }

  const style = query.data;
  const status = style.status as StyleStatus;
  const meta =
    status === "draft" || status === "po_confirmed"
      ? "Lock the costing first"
      : "What each material needs, and the next step to get it";

  return (
    <StyleCockpitChrome styleId={styleId} style={style}>
      <SectionCard title="Sourcing" meta={meta} id="sec-materials">
        <MaterialsSection styleId={styleId} styleStatus={status} />
      </SectionCard>
    </StyleCockpitChrome>
  );
}
